import { useAuth } from '../../context/AuthContext';
import { Navigate } from 'react-router-dom';
import { checkTeamRole } from '../../utils/checkRole';

export const TeamRoleGuard = ({ role, children }) => {
    const { currentUser } = useAuth();
    const hasPermission = checkTeamRole(currentUser, role);
    return hasPermission ? children : <Navigate to={'/dashboard'} />;
};
